import { render, staticRenderFns } from "./CulturalMoreGoods.vue?vue&type=template&id=07cbe91f&"
import script from "./CulturalMoreGoods.vue?vue&type=script&lang=js&"
export * from "./CulturalMoreGoods.vue?vue&type=script&lang=js&"
import style0 from "./CulturalMoreGoods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports